import { formatNumber2Decimal } from './common';
export const getDescriptionStory = (content: string, value: string) =>
  content.replace('___', `<span style="color: var(--yellow)">${value}</span>`);

export const getFeatureStory = (content: string, value: string) =>
  content.replace(
    '___',
    `<span style="color: var(--purpleLookback2); font-size: 24px; font-weight: bold;">${value}</span>`
  );
